import { mapGetters } from 'vuex';
import themeService from '@/services/themeService';
import enumFilter from '@/filters/enumFilter';
import { formatter as dateTimeFormatter } from '@/services/dateTime/datetimeService';
import { formats } from '@/constants/localizer';

export default {
  props: {
    chartData: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    labelSize: {
      type: Number,
      default: 10,
    },
    isCollapsed: {
      type: Boolean,
    },
  },
  data: () => ({
    chartImg: null,
    unit: '',
  }),
  computed: {
    ...mapGetters(['isPrinting']),
    lastRegister() {
      const { lastRegister, unit } = this.chartData;
      if (lastRegister !== null && lastRegister !== undefined) {
        return `${this.$n(lastRegister)} ${unit}`;
      }
      return '-';
    },
    fontColor() {
      return this.isPrinting
        ? themeService.getStyleVar('color-gray-medium-dark')
        : themeService.getFontColor();
    },
    bgColor() {
      return this.isPrinting
        ? themeService.getStyleVar('chart-print-background')
        : themeService.getStyleVar('color-background-dark');
    },
  },
  methods: {
    getTooltipFormatter(params) {
      const unit = this.chartData.unit || this.unit;
      return `${params.value[0]} - ${this.$n(params.value[1])} ${unit}`;
    },
    getChartSeries() {
      const series = [];
      const variables = this.chartData?.variables || [];
      variables.forEach((value) => {
        const showSymbol = value.values?.length < 2;
        const color = this.getLineColorByName(value.name);
        series.push({
          data: value
            .values
            .map(item => [dateTimeFormatter(item.x, formats.CHART), item.y]),
          type: 'line',
          lineStyle: {
            color,
          },
          itemStyle: {
            color,
          },
          showSymbol,
        });
      });
      return series;
    },
  },
  filters: {
    enumFilter,
  },
};
